import React from 'react';
import styled from 'styled-components';
import { blueColor, lightGrey2Color } from 'js/config/style';

export default styled(({ active, color, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.26 30.52" {...rest}>
    <path
      className="lock-icon"
      d="M20.35,10.17H18.9V7.27a7.27,7.27,0,1,0-14.54,0v2.91H2.91A2.92,2.92,0,0,0,0,13.08V27.62a2.92,2.92,0,0,0,2.91,2.91H20.35a2.92,2.92,0,0,0,2.91-2.91V13.08A2.92,2.92,0,0,0,20.35,10.17Zm-4.22,0h-9V7.27a4.51,4.51,0,0,1,9,0Z"
    />
  </svg>
))`
  position: relative;
  top: -1px;

  .lock-icon {
    fill: ${({ active, color }) => (active ? color || blueColor : color || lightGrey2Color)};
  }
`;
